import { useMemo } from "react";
import { useRouter } from "next/router";

import { resolveCountry } from "helpers";

export const useCountry = () => {
  const router = useRouter();
  const { country: countryQuery } = router.query;

  const country = useMemo(() => resolveCountry(countryQuery), [countryQuery]);

  return country;
};
